import { render, staticRenderFns } from "./AddProductToCartSuccessModal.vue?vue&type=template&id=36a35957"
import script from "./AddProductToCartSuccessModal.vue?vue&type=script&lang=js"
export * from "./AddProductToCartSuccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports